var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30513 4.76928C9.11388 4.70474 9.88166 4.38671 10.4992 3.86047C11.9402 2.63245 14.0596 2.63245 15.5007 3.86047C16.1182 4.38671 16.886 4.70474 17.6947 4.76928C19.582 4.91989 21.0807 6.41856 21.2313 8.30586C21.2958 9.11461 21.6139 9.8824 22.1401 10.4999C23.3681 11.9409 23.3681 14.0604 22.1401 15.5014C21.6139 16.1189 21.2958 16.8867 21.2313 17.6954C21.0807 19.5827 19.582 21.0814 17.6947 21.232C16.886 21.2966 16.1182 21.6146 15.5007 22.1408C14.0596 23.3689 11.9402 23.3689 10.4992 22.1408C9.88166 21.6146 9.11388 21.2966 8.30513 21.232C6.41783 21.0814 4.91915 19.5827 4.76855 17.6954C4.70401 16.8867 4.38598 16.1189 3.85974 15.5014C2.63171 14.0604 2.63171 11.9409 3.85974 10.4999C4.38598 9.8824 4.70401 9.11461 4.76855 8.30586C4.91915 6.41856 6.41783 4.91989 8.30513 4.76928ZM17.6622 11.3746C18.1533 10.8835 18.1533 10.0872 17.6622 9.59606C17.171 9.10491 16.3747 9.10491 15.8836 9.59606L11.7423 13.7374L10.1163 12.1114C9.62512 11.6202 8.82882 11.6202 8.33768 12.1114C7.84653 12.6025 7.84653 13.3988 8.33768 13.8899L10.853 16.4052C11.3441 16.8964 12.1404 16.8964 12.6316 16.4052L17.6622 11.3746Z",
    fill: "#00C9C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCheck);
export default __webpack_public_path__ + "static/media/button_check.f8ef9bcdd5c08e64ffadf68bdc72db12.svg";
export { ForwardRef as ReactComponent };